import React from "react";
import styles from "./Footer.module.css";
const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <a href="https://tara360.ir/" target="_blank" rel="noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/tara.svg`}
              alt=""
            />
          </a>
          <span></span>
          <a href="https://www.banimode.com/" target="_blank" rel="noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/banimode.svg`}
              alt=""
            />
          </a>
        </div>
        <div className={styles.info}>
          <p>© Copyright 2024 Banimode.com</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
